export default __webpack_public_path__ + "static/media/icon-instagram-mobile.84d4ffaf.svg";